// extracted by mini-css-extract-plugin
export default {"cls1":"r2lNTkX8fZ7n5kNXMUAB","cls2":"GiJBXGmAx8EV7iDwGECV r2lNTkX8fZ7n5kNXMUAB"};